<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.SPECIALITY' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.SPECIALITY' | translate }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="DoctorSpecialityForm">
        <div class="row m-t-30">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.SPECIALITY' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.SPECIALITY' | translate }}" formControlName="name">
                    <mat-error *ngIf="DoctorSpecialityForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="DoctorSpecialityForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{ 'LABEL.DEFAULT_LABEL' | translate }}:</strong></mat-label>
                &nbsp;
                <mat-checkbox color="warn" formControlName="isDefault"></mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-9"></div>
            <div class="col-lg-3" style="display: flex; justify-content: flex-end;">
                <button mat-stroked-button (click)="OnCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate
                    }}</button>
                <button mat-flat-button color="warn" class="m-l-4" (click)="onUpdateDoctorSpeciality()" *ngIf="isEdit"
                    [disabled]="DoctorSpecialityForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

                <button mat-flat-button color="warn" class="m-l-4" (click)="onSaveDoctorSpeciality()" *ngIf="!isEdit"
                    [disabled]="DoctorSpecialityForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            </div>
        </div>
    </form>
</div>